import Vue from 'vue';
import moment from 'moment';

Vue.filter('prettyDate', d => moment(d).format('MMMM Do, YYYY'));
Vue.filter('timeSince', d => moment(d).fromNow());



// WEBPACK FOOTER //
// ./src/filters.js